import React from 'react'
import { Link } from 'react-router-dom';
import { FaRegBell } from "react-icons/fa6";
import useNotifications, { timeAgo } from '../../../hooks/useNotifications';

// What needs attention, from real data (see hooks/useNotifications).
export default function UserNotifications({ isAdmin = false }) {
    const { items, isLoading } = useNotifications(isAdmin);

    return (
        <div className="min-h-full">
            <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                    <div className="px-4 sm:px-6 py-4 bg-gradient-to-r from-blue-600 to-indigo-600">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <FaRegBell className="w-6 h-6 text-white" />
                                <h1 className="ml-3 text-lg sm:text-2xl font-bold text-white">Notifications</h1>
                            </div>
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs sm:text-sm font-medium bg-white text-indigo-600">
                                {items.length} New
                            </span>
                        </div>
                    </div>

                    <div className="divide-y divide-gray-200">
                        {isLoading && <p className="px-6 py-8 text-center text-gray-500">Loading…</p>}
                        {!isLoading && items.length === 0 && (
                            <p className="px-6 py-10 text-center text-gray-500">You're all caught up. New website messages and replies from the Masjid Hub team will show here.</p>
                        )}
                        {items.map((n) => (
                            <Link key={n.id} to={n.to} className="block px-4 sm:px-6 py-5 bg-white hover:bg-gray-50 transition-colors duration-200">
                                <div className="flex justify-between items-start">
                                    <div className="flex-1 min-w-0">
                                        <p className="text-sm font-semibold text-gray-900">{n.title}</p>
                                        {n.text && <p className="mt-1 text-sm text-gray-500 line-clamp-2">{n.text}</p>}
                                    </div>
                                    {n.time && <p className="ml-4 flex-shrink-0 text-xs text-gray-400">{timeAgo(n.time)}</p>}
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
